import { VARIABLE_REGEX } from './constants.js';
import { safeStringifyValue } from './utils.js';

class VariableDependencyConfig {
  constructor(_sceneObject, _options) {
    this._sceneObject = _sceneObject;
    this._options = _options;
    this._dependencies = /* @__PURE__ */ new Set();
    this.scanCount = 0;
    this.defaultHandlerReferencedVariableValueChanged = () => {
      this._sceneObject.forceRender();
    };
    this._statePaths = _options.statePaths;
  }
  hasDependencyOn(name) {
    return this.getNames().has(name);
  }
  variableUpdatesCompleted(changedVariables) {
    const deps = this.getNames();
    let dependencyChanged = false;
    for (const variable of changedVariables) {
      if (deps.has(variable.state.name)) {
        dependencyChanged = true;
        break;
      }
    }
    if (this._options.onVariableUpdatesCompleted) {
      this._options.onVariableUpdatesCompleted(changedVariables, dependencyChanged);
      return;
    }
    if (dependencyChanged) {
      if (this._options.onReferencedVariableValueChanged) {
        this._options.onReferencedVariableValueChanged();
      } else {
        this.defaultHandlerReferencedVariableValueChanged();
      }
    }
  }
  getNames() {
    const prevState = this._state;
    const newState = this._state = this._sceneObject.state;
    if (!prevState) {
      this.scanStateForDependencies(this._state);
      return this._dependencies;
    }
    if (newState !== prevState) {
      if (this._statePaths) {
        for (const path of this._statePaths) {
          if (newState[path] !== prevState[path]) {
            this.scanStateForDependencies(newState);
            break;
          }
        }
      } else {
        this.scanStateForDependencies(newState);
      }
    }
    return this._dependencies;
  }
  setPaths(paths) {
    this._statePaths = paths;
  }
  scanStateForDependencies(state) {
    this._dependencies.clear();
    this.scanCount += 1;
    if (this._options.variableNames) {
      for (const name of this._options.variableNames) {
        this._dependencies.add(name);
      }
    } else {
      if (this._statePaths) {
        for (const path of this._statePaths) {
          const value = state[path];
          if (value) {
            this.extractVariablesFrom(value);
          }
        }
      } else {
        this.extractVariablesFrom(state);
      }
    }
  }
  extractVariablesFrom(value) {
    VARIABLE_REGEX.lastIndex = 0;
    const stringToCheck = typeof value !== "string" ? safeStringifyValue(value) : value;
    const matches = stringToCheck.matchAll(VARIABLE_REGEX);
    if (!matches) {
      return;
    }
    for (const match of matches) {
      const [, var1, var2, , var3] = match;
      const variableName = var1 || var2 || var3;
      this._dependencies.add(variableName);
    }
  }
}

export { VariableDependencyConfig };
//# sourceMappingURL=VariableDependencyConfig.js.map
